import {Route} from '@angular/router';
import {IrbAuthenticationGuard} from '@irb/irb-authentication/irb-authentication.guard';
import {IrbNavigationGuard} from '@irb-common/modules/main-menu/main-menu.navigation.guard';
import {DevelopmentGuard} from "@irb-common/modules/main-menu/main-menu.development.guard";
import {IrbOrdersGuard} from "@irb/irb-orders/irb-orders.guard";

export const ROUTES: Route[] = [
  {
    path: '',
    loadChildren: () => import('./irb-authentication/irb-authentication.module').then(m => m.IrbAuthenticationModule)
  },
  {
    path: 'initial-setup',
    loadChildren: () => import('./irb-initial-setup/irb-initial-setup.module').then(m => m.IrbInitialSetupModule),
    canActivate: [IrbAuthenticationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'home',
    loadChildren: () => import('./irb-dashboard/irb-dashboard.module').then(m => m.IrbDashboardModule),
    canActivate: [IrbAuthenticationGuard],
    canDeactivate: [IrbNavigationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'gs-securities',
    loadChildren: () => import('./irb-settings/irb-settings.module').then(m => m.IrbSettingsModule),
    canActivate: [IrbAuthenticationGuard],
    canDeactivate: [IrbNavigationGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./irb-reports/irb-reports.module').then(m => m.IrbReportsModule),
    canActivate: [IrbAuthenticationGuard],
    canDeactivate: [IrbNavigationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'clients',
    loadChildren: () => import('./irb-clients/irb-clients.module').then(m => m.IrbClientsModule),
    canActivate: [IrbAuthenticationGuard],
    canDeactivate: [IrbNavigationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'models',
    loadChildren: () => import('./irb-models/irb-models.module').then(m => m.IrbModelsModule),
    canActivate: [IrbAuthenticationGuard],
    canDeactivate: [IrbNavigationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'rebalancing',
    loadChildren: () => import('./irb-rebalance/irb-rebalance.module').then(m => m.IrbRebalanceModule),
    canActivate: [IrbAuthenticationGuard],
    canDeactivate: [IrbNavigationGuard]
  },
  {
    path: 'orders',
    loadChildren: () => import('./irb-orders/irb-orders.module').then(m => m.IrbOrdersModule),
    canActivate: [IrbAuthenticationGuard,IrbOrdersGuard],
    canDeactivate: [IrbNavigationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'ui',
    loadChildren: () => import('./irb-ui/irb-ui.module').then(m => m.IrbUiModule),
    canActivate: [DevelopmentGuard, IrbAuthenticationGuard],
    canDeactivate: [IrbNavigationGuard]
  },
  {
    path: 'healthcheck',
    redirectTo: 'home'
  },
  {
    path: '**',
    redirectTo: ''
  }
];